import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function BaggageMDisabledStrokeIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<path
				d="M5.47003 16.62V13.13C5.47003 11.69 6.62003 10.44 8.16003 10.44H9.31003V3.34H9.12003C8.74003 3.34 8.35003 3.05 8.35003 2.57C8.35003 2.09 8.64003 1.8 9.12003 1.8H14.88C15.26 1.8 15.65 2.09 15.65 2.57C15.65 3.05 15.36 3.34 14.88 3.34H14.69V7.4L13.15 8.94V3.34H10.85V10.45H11.65L10.11 11.99H8.16003C7.49003 11.99 7.01003 12.57 7.01003 13.14V15.09L5.47003 16.63V16.62ZM18.53 13.13V18.41C18.53 19.79 17.47 20.99 16.03 21.09V21.77C16.03 22.25 15.65 22.54 15.36 22.54H14.88C14.5 22.54 14.11 22.25 14.11 21.77V21.1H9.88003V21.77C9.88003 22.25 9.50003 22.54 9.21003 22.54H8.73003C8.35003 22.54 7.96003 22.25 7.96003 21.77V21.09C7.23003 21.04 6.56003 20.69 6.10003 20.15L3.06003 23.19L2.03003 22.16L5.48003 18.71C5.48003 18.7 5.48003 18.69 5.48003 18.68L7.00003 17.16V17.19L9.80003 14.39H9.77003L11.03 13.13H11.06L12.2 11.99H12.17L14.68 9.48V9.51L21.98 2.2L23.01 3.23L15.8 10.44H15.83C17.27 10.44 18.52 11.59 18.52 13.13H18.53ZM16.99 13.13C16.99 12.46 16.41 11.98 15.84 11.98H14.27L13.13 13.12H14.41C14.76 13.12 15.04 13.4 15.04 13.75C15.04 14.1 14.76 14.38 14.41 14.38H13.53V15.46C13.53 15.76 13.29 16 12.99 16C12.69 16 12.45 15.76 12.45 15.46V14.38H11.86L7.19003 19.05C7.41003 19.37 7.78003 19.57 8.15003 19.57H15.83C16.5 19.57 16.98 18.99 16.98 18.42V13.14L16.99 13.13Z"
				fill="currentColor"
			/>
		</svg>
	);
}

BaggageMDisabledStrokeIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default BaggageMDisabledStrokeIcon;
